/*
 * @Author: caiqin.xie
 * @since: 2023-07-14 10:30:10
 * @lastTime: 2023-11-22 15:04:33
 * @LastEditors: caiqin.xie
 * @message: 服务支持-搜索结果页
 * @url: www.picoxr.com/cn/support/search
 */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Pagination from '@/components/Pagination';
import Search from "./components/Search";
import ResultList from "./components/ResultList";
import { useDevice } from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_LIST, COUNTRY_HREFLANG } from '@/common/const'
import { getUrlData } from '@/common/untils'
import styles from "./index.module.scss";
const _ = require('lodash')

interface IList {
  id: string;
  title: string; // 标题
  briefIntroduction: string; // 简介
  dataType: number; // 数据类型 1-内容 2-门店 3-产品
  contentTypeId: string; // 内容类型id
  seoUrl: string; // 地址栏显示名称
  [key: string]: any;
}

interface IPayload {
  stationCode: string; // 站点
  rows: number; // 每页显示条数
  page: number; // 当前页
  keyword?: string; // 搜索关键字
  keyword1?: string; // 搜索标签
}

const SearchResult = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const {search} = useLocation()
  const query = getUrlData(decodeURIComponent(search)) // 获取url参数
  const [keyword, setkeyword] = useState<string>(query?.keyword as string || '') // 搜索关键字
  const [labelName, setLabelName] = useState<string>(query?.labelName as string || '') // 搜索标签
  const [pageNum, setPageNum] = useState<number>(query.page ? Number(query.page) : 1) // 当前页
  const [pages, setPages] = useState<number>(data.pages * 1) // 总页数
  const [total, setTotal] = useState<number>(data.total * 1) // 总条数
  const [list, setList] = useState<IList[]>(data.records || []) // 搜索结果
  const [allList, setAllList] = useState<IList[]>(data.records || []) // 所有搜索数据

  // 分页改变
  const pageChange =(pageNum: number) => {
    setPageNum(pageNum)
    if (device === 'pc') {
      if (pageNum === 1) {
        labelName ? window.open(`/${ctry}/support/search?keyword=${keyword}&labelName=${labelName}`, '_self')
        : window.open(`/${ctry}/support/search?keyword=${keyword}`, '_self')
      } else {
        labelName ? window.open(`/${ctry}/support/search?keyword=${keyword}&labelName=${labelName}&page=${pageNum}`, '_self')
        : window.open(`/${ctry}/support/search?keyword=${keyword}&page=${pageNum}`, '_self')
      }
    } else {
      getResultList(pageNum)
    }
  }

  // 搜索列表 (处理pad和移动端分页数据)
  const getResultList = (pageNum: number) => {
    const payload = {
      stationCode: ctry,
      rows: 10,
      page: pageNum,
      keyword,
      keyword1: labelName
    }
    getList(payload)
    .then((res:any) => {
      const {total, records, pages} = res
      setTotal(total * 1)
      setPages(pages * 1)
      setList(records)
      setAllList(allList => _.uniqBy([...allList, ...records], 'id'))
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 搜索
  const searchFun = (keyword: string, labelName: string) => {
    setAllList([])
    labelName ? window.open(`/${ctry}/support/search?keyword=${keyword}&labelName=${labelName}`, '_self')
    : window.open(`/${ctry}/support/search?keyword=${keyword}`, '_self')
  }


  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/search`} />
      ))
    )
  }
  return (
    <div>
      <Helmet>
        <title>{words.support_search_seo_title}</title>
        <meta name="description" content={words.support_search_seo_description} />
        <meta name="keywords" content={words.support_search_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/search`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['result-wrap']}>
        <div className={styles['result-content-wrap']}>
          <Search
            ctry={ctry}
            words={words}
            keyword={keyword}
            labelName={labelName}
            searchFun={searchFun}
            setkeyword={setkeyword} />
          <p className={styles['total-result']}>{ words?.common_total_result }{total}</p>
          <ResultList
            ctry={ctry}
            device={device}
            resultList={list}
            allList={allList} />

          {/* 分页 */}
          <Pagination
            words={words}
            device={device}
            pageNum={pageNum}
            pages={pages}
            total={total}
            pageChange={pageChange} />
        </div>
      </main>
      <Footer />
    </div>
  );
};
// 获取列表公共方法
function getList (payload: IPayload) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/support/getSupportSearchPage`, {
      ...payload
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}
SearchResult.getInitialProps = (ctry: string, pathName: string) => {
  const decodedUrl = decodeURIComponent(pathName);
  const param = getUrlData(decodedUrl)
  return getList({
    page: param.page ? Number(param.page) : 1,
    rows: 10,
    stationCode: ctry,
    keyword: param?.keyword as string,
    keyword1: param?.labelName as string
  })
};
export default SearchResult;
